import React, { useState, useEffect } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

export default function OfflineAlert() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      // Esconder a mensagem de "reconectado" após 3 segundos
      setTimeout(() => setShowReconnected(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowReconnected(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Não mostrar nada se estiver online e não acabou de reconectar
  if (isOnline && !showReconnected) {
    return null;
  }

  // Mensagem de reconexão
  if (isOnline && showReconnected) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[9999] bg-green-500 text-white py-2 px-4 text-center animate-in slide-in-from-top duration-300">
        <div className="flex items-center justify-center gap-2">
          <RefreshCw className="h-4 w-4" />
          <span className="text-sm font-medium">Conexão restabelecida</span>
        </div>
      </div>
    );
  }

  // Alerta de offline
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-red-500 text-white py-3 px-4 text-center shadow-lg animate-in slide-in-from-top duration-300">
      <div className="flex items-center justify-center gap-3">
        <WifiOff className="h-5 w-5 animate-pulse" />
        <div className="text-left">
          <p className="text-sm font-bold">Sem conexão à Internet</p>
          <p className="text-xs opacity-90">Os dados não podem ser carregados. Verifique a sua ligação.</p>
        </div>
      </div>
    </div>
  );
}
